var render = function render(){var _vm=this,_c=_vm._self._c;return _c('EditColumn',{attrs:{"submitText":"Create Record","title":"Create a Record","loading":_vm.addStatus === 'adding',"error":_vm.addError},on:{"submit":_vm.handleSubmit,"cancel":_vm.handleCancel}})
}
var staticRenderFns = []

export { render, staticRenderFns }